import { render, staticRenderFns } from "./WAttachmentModal.yaml?vue&type=template&id=5f890ebd&component"
import script from "./WAttachmentModal.yaml?vue&type=script&lang=ts&component"
export * from "./WAttachmentModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports